<div>
  @if (isBrowser) {
    <ngx-extended-pdf-viewer [src]="revista()[0]?.url" height="70vh" zoom="50%" [showPresentationModeButton]="true" [showSecondaryToolbarButton]="false" [showRotateButton]="false" [showPrintButton]="false" [showOpenFileButton]="false" [filenameForDownload]="revista()[0]?.nombre + '.pdf'" [showDownloadButton]="false" [scrollMode]="1"> </ngx-extended-pdf-viewer>
  }
</div>

<div class="container-info">
  <span class="revista-nombre">{{ revista()[0]?.nombre }}</span>
  <span class="revista-fecha">Publicado el {{ formatDate(revista()[0]?.fecha) | date: "d MMM. y" }}</span>
  <span class="revista-genero">{{ revista()[0]?.genero }}</span>
  <span>{{ revista()[0]?.descripcion }}</span>
</div>
